import { render, staticRenderFns } from "./FileRequestUploader.vue?vue&type=template&id=3fa546f2&scoped=true&"
import script from "./FileRequestUploader.vue?vue&type=script&lang=js&"
export * from "./FileRequestUploader.vue?vue&type=script&lang=js&"
import style0 from "./FileRequestUploader.vue?vue&type=style&index=0&id=3fa546f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa546f2",
  null
  
)

export default component.exports